export const COMPANY_GRANTED_LIST_REQUEST = 'COMPANY_GRANTED_LIST_REQUEST';
export const COMPANY_GRANTED_LIST_SUCCESS = 'COMPANY_GRANTED_LIST_SUCCESS';

export const COMPANY_USER_SEARCH_REQUEST = 'COMPANY_USER_SEARCH_REQUEST';
export const COMPANY_USER_SEARCH_SUCCESS = 'COMPANY_USER_SEARCH_SUCCESS';

export const COMPANY_USER_CREATE = 'COMPANY_USER_CREATE';
export const COMPANY_GRANT_ADD = 'COMPANY_GRANT_ADD';
export const COMPANY_GRANT_DELETE = 'COMPANY_GRANT_DELETE';
